<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "PurgeAllUnprotectedGlyphsModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      isRefining: false,
      isSacrificing: false,
    };
  },
  computed: {
    refiningSacrificingOrDeleting() {
      if (this.isRefining) return `Переработать`;
      if (this.isSacrificing) return `Жертвовать`;
      return `удалить`;
    },
    refiningSacrificingOrDeleting2() {
      if (this.isRefining) return `Переработает`;
      if (this.isSacrificing) return `Пожертвует`;
      return `удалит`;
    },
    topLabel() {
      return `Вы собираетесь ${this.refiningSacrificingOrDeleting} все незащищённые Гилифы`;
    },
    message() {
      return `Вы уверены, что хотите ${this.refiningSacrificingOrDeleting} все незащищённые Глифы
        в вашем инвентаре?`;
    },
    extraMessage() {
      if (this.glyphsDeleted === 0) return `Это не ${this.refiningSacrificingOrDeleting2} никакие глифы.`;
      if (this.glyphsDeleted === this.glyphsTotal) {
        return `Это ${this.refiningSacrificingOrDeleting2} все ваши Глифы.`;
      }
      return `Это ${this.refiningSacrificingOrDeleting2} 
        ${formatInt(this.glyphsDeleted)}/${formatInt(this.glyphsTotal)} ваших Глифа.`;
    },

    // These two don't need to be reactive since the modal force-closes itself whenever glyphs change
    glyphsTotal() {
      return Glyphs.inventory.filter(slot => slot !== null).length;
    },
    glyphsDeleted() {
      return Glyphs.autoClean(0, false);
    },
  },
  methods: {
    update() {
      this.isRefining = GlyphSacrificeHandler.isRefining;
      this.isSacrificing = GlyphSacrificeHandler.canSacrifice;
    },
    handleYesClick() {
      Glyphs.deleteAllUnprotected();
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="sacrificeAll"
    @confirm="handleYesClick"
  >
    <template #header>
      {{ topLabel }}
    </template>
    <div class="c-modal-message__text">
      {{ message }}
    </div>
    <br>
    <div class="c-modal-hard-reset-danger">
      {{ extraMessage }}
    </div>
  </ModalWrapperChoice>
</template>
